<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="((corporateTaxEntity$ | async)?.aangifte?.balansEnResultatenrekening?.kostenEgalisatieReserve?.at(0)?.slotbalans ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="tm" size="lg"
                                title="Specificatie kostenegalisatiereserve">
  <snelstart-ui-dialog-body>
    <div style="max-width: 90%">
      <form [formGroup]="voorzieningFg">
        <div class="row pt-3">
          <div class="col col-1">
            <p>Bedrag volgens openingsbalans</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              placeholder="0"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>

        <div class="row">
          <div class="col col-1">
            <p>Bij: dotatie</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="dotatie"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>

        <div class="row">
          <div class="col col-1">
            <p>Af: onttrekking</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="onttrekking"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>

        <div class="row">
          <div class="col col-1">
            <p>Bedrag volgens slotbalans</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>

        @if (getTotaal() !== 0) {
          <snelstart-ui-alert class="pt-3" type="warning">
            Een bedrag van € {{ this.getTotaal()  | number: '1.0-0' }} is nog niet gespecificeerd.
          </snelstart-ui-alert>
        }
      </form>
    </div>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button [disabled]="getTotaal() !== 0" icon="check" id="noSave" type="primary">
      Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
